import { useI18n } from "../context/I18nContext";
import { downloadReport } from "../lib/api";
import { FileText, FileSpreadsheet } from "lucide-react";
import { toast } from "sonner";

export const ExportButtons = ({ path, filename, testid }) => {
  const { t } = useI18n();
  const dl = async (fmt) => {
    try {
      const sep = path.includes("?") ? "&" : "?";
      await downloadReport(`${path}${sep}format=${fmt}`, `${filename}.${fmt === "xlsx" ? "xlsx" : "pdf"}`);
    } catch (e) { toast.error("Export error"); }
  };
  return (
    <div className="flex gap-1.5">
      <button onClick={() => dl("pdf")} data-testid={`${testid}-pdf`}
        className="inline-flex items-center gap-1 border px-2.5 h-8 text-xs font-medium hover:bg-muted transition-colors">
        <FileText size={13} /> {t("rp.pdf")}
      </button>
      <button onClick={() => dl("xlsx")} data-testid={`${testid}-xlsx`}
        className="inline-flex items-center gap-1 border px-2.5 h-8 text-xs font-medium hover:bg-muted transition-colors">
        <FileSpreadsheet size={13} /> {t("rp.excel")}
      </button>
    </div>
  );
};
